import { createSlice } from "@reduxjs/toolkit";

const initialClustermahasiswaState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  clustermahasiswaForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const clustermahasiswaSlice = createSlice({
  name: "clustermahasiswa",
  initialState: initialClustermahasiswaState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		clustermahasiswaFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		clustermahasiswaAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    clustermahasiswaCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.clustermahasiswa.push(action.payload.clustermahasiswa);
    },
    clustermahasiswaDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.clustermahasiswa.filter(el => el.clustermahasiswa_id !== action.payload.id);
    },
    getClustermahasiswa: (state, action) => {
      state.actionsLoading = false;
      state.clustermahasiswaForEdit = action.payload.clustermahasiswaForEdit;
      state.error = null;
    },
    // updateProduct
    clustermahasiswaUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.clustermahasiswa = state.entities.clustermahasiswa.map(entity => {
        if (entity.clustermahasiswa_id === action.payload.clustermahasiswa.clustermahasiswa_id) {
          return action.payload.clustermahasiswa;
        }
        return entity;
      });
    },
  },
});
